/**
 * Whether or not a value is a function
 */
export function isFunction(v) {
    return typeof v === 'function';
}
/**
 * Whether a function is running on the browser or the server
 * (for server-side rendering)
 */
export function isBrowser() {
    return typeof window !== 'undefined';
}
/**
 * Whether something is a promise. (This can be used to figure out whether an object should be awaited
 * or handled as is)
 */
export function isPromise(v) {
    return !!v && typeof v === 'object' && 'then' in v && typeof v.then === 'function';
}
/**
 * Checks if a value is nullish (null or undefined)
 *
 * @param v The value
 * @returns A boolean value representing whether the value is nullish
 */
export function isNullish(v) {
    return v === null || v === undefined;
}
/**
 * Checks whether a value is a string
 * @param v the value
 */
export function isString(v) {
    return typeof v === 'string';
}
